import { render, staticRenderFns } from "./cascadeResource.vue?vue&type=template&id=7b4b0b94&scoped=true"
import script from "./cascadeResource.vue?vue&type=script&lang=js"
export * from "./cascadeResource.vue?vue&type=script&lang=js"
import style0 from "./cascadeResource.vue?vue&type=style&index=0&id=7b4b0b94&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4b0b94",
  null
  
)

export default component.exports